import { Component } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import {AirManagementService}  from 'src/app/services/air-management.service'
import {AirConfigService}  from 'src/app/services/air-config.service'
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { ColorsService } from 'src/app/services/colors.service';
import { Subscription } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { Router ,ActivatedRoute} from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';

enum MyEnum {
  FirstValue,
  SecondValue,
}
@Component({
  selector: 'app-air-config',
  templateUrl: './air-config.component.html',
  styleUrls: ['./air-config.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class AirConfigComponent {
  action:any
  numbers: number[] = Array.from({ length: 25 }, (_, i) => i + 1);
  tourData:any=[]
  fareData:any=[]
  SourceData:any
  addfare:boolean=false
  AddTourCodes:boolean=false
  showGenSave:boolean=false
  showRBD:boolean=true
  sourceList:any=[]
  generalconfigData:any
  columnsToDisplay: string[] = ['source','b2e','b2b','b2c','timeBefore','changeClass','button'];
  columnsToDisplayWithExpand = ['expand', ...this.columnsToDisplay];
  columnsTourCodeWithExpand:string[] = ['enabled','tourCode','fareCode','supplier','source','carrier'];
  columnsFareWithExpand:string[]=[ 'enabled','privateFareCode','priority','sourceCode','supplierCode','carrierCode'];
  GenRegFg!:FormGroup;
  CacheRegFg!:FormGroup;
  showCacheUpdate:boolean=false
  showfareRules:boolean=false

  SourceRegFg!:FormGroup;
  TourRegFg!:FormGroup;
  fareRegFg!:FormGroup;
  dataSource:any = [];
  expandedElement!: any | null;
  showGeneralConfig:boolean=false
  showSourceConfig:boolean=false
  showCacheConfig:boolean=false
  showTourCodes:boolean=false
  showFares:boolean=false
  id:any='lock'
  foo = MyEnum.FirstValue;
  bar = MyEnum.SecondValue;
  confirmExp:boolean=false
  CacheExp:boolean=false
  searchExp:boolean=false
  DomCacheExp:boolean=false
  userType:any
  color:any
constructor(    private userPrivileges: UserPrivilegeService,
  private UserInfoService:UserInfoService, private DataService:DataService, private location:Location,private AirManagementService:AirManagementService,private cdr: ChangeDetectorRef,private route :ActivatedRoute,
 private AirConfigService:AirConfigService,private fb : FormBuilder,    private toastMsgService : ToastmsgService,private ColorsService:ColorsService){

  this.userPrivileges.userPrivilegesByModule('Air-Config').then((privileges:any) => {
    this.privilegesValue(privileges)
  })
  .catch((error:any) => {
  console.error(error); // Handle errors, if any
  });

  this.ColorsService.colors("","").then((color:any) => {
    this.color=color
   })
   .catch((error:any) => {
   });
  this.sourceCodelist()
  this.userType=this.UserInfoService.getUserType()
  this.userType=this.userType.toUpperCase()

this.route.queryParams.subscribe(params => {
  let data:any
  data=params
  if(data.id){
  this.id=this.decodeTransformedcode(data.id)
 console.log(this.id)}
 if(this.id==='airConfigNull'){
  this.id=null
 }
 // for(let i=0 ;i <data.length; i++){ this.email +=data[i]; }
  
  

    });
    this.onClickGeneral()
    this.supplierlist()
}

privilegesView:any
privilegesValue(privs:any){
   
  let privileges="";

if(privs.includes('view')){
  this.privilegesView="VAMD"
}else{
  this.privilegesView="AccessDenied"
}

}
transformcode(email: string): string {
  let result = '';

  for (let i = 0; i < email.length; i++) {
    const char = email.charCodeAt(i);
    result += char.toString(16); // Convert the character code to a hexadecimal string
  }

  return result;
}
decodeTransformedcode(encodedEmail: string): string {
  let result = '';

  for (let i = 0; i < encodedEmail.length; i += 2) {
    const hexChar = encodedEmail.slice(i, i + 2);
    const charCode = parseInt(hexChar, 16); // Convert the hexadecimal string to a character code
    result += String.fromCharCode(charCode);
  }

  return result;
}
dataFields(){

this.GenRegFg=this.fb.group({
  "airProduct" :  [String(this.generalconfigData?.airProduct||false),[Validators.required]],
  "b2bEnabled" : [String(this.generalconfigData?.b2bEnabled||false),[Validators.required]],
  "b2eEnabled" : [String(this.generalconfigData?.b2eEnabled||false),[Validators.required]],
  "b2cEnabled":[String(this.generalconfigData?.b2cEnabled||false),[Validators.required]],
  "domesticEnabled":[String(this.generalconfigData?.domesticEnabled||false),[Validators.required]],
  "internationalEnabled":[String(this.generalconfigData?.internationalEnabled||false),[Validators.required]],
  "domesticMultiEnabled":[String(this.generalconfigData?.domesticMultiEnabled||false),[Validators.required]]
});
}

onClickTour(){
  this.fareList()
 
  this.Sourcelist();
  this.Carrierlist();
  this.showRBD=false

  this.showSourceConfig=false
  this.showCacheConfig=false
  this.showGeneralConfig=false
  this.showFares=false
  this.showfareRules=false
  this.showTourCodes=true
 this.tourCodeDetails()
 this.tourList()
  
}
tourCodeDetails(){
  this.TourRegFg=this.fb.group({
    "sourceCode": ['',[Validators.required]],
    "supplierCode": ['',[Validators.required]],
    "carrierCode": [''],
    "priority": [''],
    "os": [''],
    "cabinClass": [''],
    "viaPoint": [''],
    "travelValidity": [''],
    "flightRegex": [''],
    "sector": [''],
    "travelBlackout": [''],
    "endorsement": [''],
    "classRegex": [''],
    "origin": ['',],
    "salesValidity": ['',],
    "basisRegex": [''],
    "destination": [''],
    "salesBlackout": [''],
    "pfTourCode": [''],
    "expiryDate": [''],
    "journeyType": ['',],
    "netDiscount": ['',],
    "domIntl": [''],
    "status": [,[Validators.required]],
    "state": ['',],
    "code":['',[Validators.required]],
    "pfCode":[''],

  });
}
onClickFare(){
  this.Sourcelist();
  this.Carrierlist();
  this.showRBD=false

  this.showTourCodes=false
  this.showSourceConfig=false
  this.showCacheConfig=false
  this.showGeneralConfig=false
  this.showfareRules=false
  this.showFares=true
 this.fareDetails()
 this.fareList()

}
onClickfairRules(){
  let data:any={
    boolean:false,
    action:''
  }
  this.DataService.deliverMsg(data)
  this.showRBD=false

  this.showTourCodes=false
  this.showSourceConfig=false
  this.showCacheConfig=false
  this.showGeneralConfig=false
  this.showFares=false
  this.showfareRules=true
}
fareDetails(){
  this.fareRegFg=this.fb.group({
    "sourceCode": ['',[Validators.required]],
    "supplierCode": ['',[Validators.required]],
    "carrierCode": ['',[Validators.required]],
    "priority": ['',[Validators.required]],
    "groupId": [],
    "domIntl":[''],
    "privateFareCode":['',[Validators.required]],
    "enabled":[true,[Validators.required]]
  });
}
onClickGeneral(){
  this.showRBD=false

  this.showTourCodes=false
  this.showFares=false
  this.showSourceConfig=false
  this.showCacheConfig=false
  this.showfareRules=false
  this.showGeneralConfig=true
  this.generalConfig();
  this.dataFields()
}
 

  onClickCache(){
    this.showRBD=false

    this.showTourCodes=false
    this.showFares=false
    this.showGeneralConfig=false
    this.showSourceConfig=false
    this.showfareRules=false
    this.showCacheConfig=true
    this.getCache()
    this.cacheDataFields()
    
  }
cacheDataFields(){
  this.CacheRegFg=this.fb.group({
    
    "domCacheEnabled": [this.CacheData?.domCacheEnabled?.toString(),[Validators.required]],
    "internationalCacheEnabled":[this.CacheData?.internationalCacheEnabled?.toString(),Validators.required],
    "domCacheExpiryTime":[this.CacheData?.domCacheExpiryTime,Validators.required],
    "internationalCacheExpiryTime": [this.CacheData?.internationalCacheExpiryTime,Validators.required],
    "itinerarySearchExpiryTime":[this.CacheData?.itinerarySearchExpiryTime,Validators.required],
    "itineraryConfirmExpiryTime": [this.CacheData?.itineraryConfirmExpiryTime,Validators.required]
  });
}
  onClickSource(){
    this.showRBD=false

    this.showTourCodes=false
   this.showFares=false
    this.showGeneralConfig=false
    this.showCacheConfig=false
    this.showfareRules=false
    this.showSourceConfig=true
    this.Sourcelist();

    this.SourceRegFg=this.fb.group({
      "supplierCode": [''],
      "sourceCode": [''],
    "userName":[''],
    "password":[''],
    "url":['',],
    "officeId":[''],
    "clientId":[''],
    "currency":[''],
    "transactionPassword":[''],
    "transactionId":[''],
    "profile":[''],
    "transactionProfile":[''],
    "farePcc":[''],
    "searchPcc":[''],
    "b2bEnabled":[''],
    "b2eEnabled":[''],

    "b2cEnabled":[''],
    "timeBeforeSearch":[''],
    "changeClassOption":[''],
    "productClass":[''],
    "nonRefundableProductClass":[''],
    "fareType":[''],
    "fareBasis":[''],
    "nonRefundableFareBasisCode":[''],
      });

  }

  onClickRBD(){
    this.showTourCodes=false
    this.showFares=false
    this.showGeneralConfig=false
    this.showSourceConfig=false
    this.showfareRules=false
    this.showCacheConfig=false
    this.showRBD=true

  }
  backClick(){
    this.location.back()
      }

      formatDate(val: Date) {
        let convertedValue:any = ""
        if(val){
        let datepipe = new DatePipe("en");
        //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
        convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
        }
        return convertedValue;
      }

      Sourcelist(){
        let uuid:any
        if(this.id){
        uuid=this.id
        }else{
          uuid="0"
        }
        this.AirManagementService
        .sourcelistbyUUId(uuid)
        .subscribe({
          next : (res:any) => {
            if(res) {
           let data:any=[]
           data=res
           this.sourceList=data
           console.log(this.sourceList)
           for(let j=0;j<this.sourceList.length;j++){
            this.sourceList[j].sourceConfig= [{
              "sourceCode": undefined,
              "supplierCode": undefined,
              "userName":undefined,
              "password": undefined,
              "url": undefined,
              "officeId": undefined,
              "clientId": undefined,
              "currency":undefined,
              "profile": undefined,
              "transactionPassword": undefined,
              "transactionId": undefined,
              "transactionProfile": undefined,
              "farePcc":undefined,
              "searchPcc": undefined,
              "b2bEnabled": undefined,
              "b2eEnabled": undefined,
              "b2cEnabled": undefined,
              "timeBeforeSearch": undefined,
              "changeClassOption": undefined,
              "status": undefined,
              "state": undefined,
              "carrierRule":undefined,
              "include":undefined,
              "exclude":undefined,
              "productClass":undefined,
              "nonRefundableProductClass":undefined,
              "fareType":undefined,
              "fareBasis":undefined,
              "nonRefundableFareBasisCode":undefined,


          }]}
           this.getSourceConfig()
            } else {
            
            } 
          },error : (err) => {
    
          }
        }
      )
      }
     
     
      Change(event:any,type:any){
        if(type==='confirmExp'){
          if(event.target.value===undefined || event.target.value===""){
            this.confirmExp=false
          }else{
            this.confirmExp=true
          }
        }
        else if(type==='CacheExp'){
          if(event.target.value===undefined || event.target.value===""){
            this.CacheExp=false
          }else{
            this.CacheExp=true
          }
        }
        else if(type==='searchExp'){
          if(event.target.value===undefined || event.target.value===""){
            this.searchExp=false
          }else{
            this.searchExp=true
          }
        }
        else if(type==='DomCacheExp'){
          if(event.target.value===undefined || event.target.value===""){
            this.DomCacheExp=false
          }else{
            this.DomCacheExp=true
          }
        }
       
       
      }
      onlyNumberKey(event:any) {
     
        let charCode = (event.which) ? event.which : event.keyCode;
        if (charCode != 46 && charCode > 31
            && (charCode < 48 || charCode > 57))
            return false;
        return true;
      }

      generalConfig(){

        let uuid:any
      if(this.id){
      uuid=this.id
      }else{
        uuid="0"
      }
        this.AirConfigService
        .getGeneralConfig(uuid)
        .subscribe({
          next : (res:any) => {
            if(res) {
              let data=res
              if(data.length>0){
            this.showGenSave=true
              }else{
                this.showGenSave=false

              }
         this.generalconfigData=data[0]
         this.dataFields()
 
            } else {
            
            } 
          },error : (err) => {
    
          }
        }
      )
      }

      AddGeneralConfig() {
        let uuid:any
        if(this.id){
        uuid=this.id
        }else{
          uuid="0"
        }
        this.AirConfigService.saveGeneral(this.GenRegFg.value,uuid)
          .subscribe({
            next : (res) => {
              if(res.status==200 || res.status==201) {
                this.toastMsgService.setMsg({msg : "General Config Added Successfully!",msgTitle : "Success", msgType : "I"});
              
              this.generalConfig()
    
              } else {
                const body : any = res.body;
                this.registerGroupErrorMsg(res.status,body?.result);
              } 
    
            },error : (err) => {
    
              this.registerGroupErrorMsg(err.status,err.error);
            }
          }
        )
      }
    
      registerGroupErrorMsg(status : number,msg : string) {
        if(status >=500) {
          this.toastMsgService.setMsg({msg : "Failed to save General Config",msgTitle : "Warning", msgType : "W"});
        } else {
    
          this.toastMsgService.setMsg({msg : "Failed to save General Config",msgTitle:  "Warning", msgType : "W"});
        } 
      }
      updateGeneralConfig() {
        let uuid:any
        if(this.id){
        uuid=this.id
        }else{
          uuid="0"
        }
        this.AirConfigService.UpdateGeneral(this.GenRegFg.value,uuid)
          .subscribe({
            next : (res) => {
              if(res.status==200 || res.status==201) {
                this.toastMsgService.setMsg({msg : "General Config Updated Successfully!",msgTitle : "Success", msgType : "I"});
                this.generalConfig()
              
    
              } else {
                const body : any = res.body;
                this.registerGenupdateErrorMsg(res.status,body?.result);
              } 
    
            },error : (err) => {
    
              this.registerGenupdateErrorMsg(err.status,err.error);
            }
          }
        )
      }
    
      registerGenupdateErrorMsg(status : number,msg : string) {
        if(status >=500) {
          this.toastMsgService.setMsg({msg : "Failed to Update General Config",msgTitle : "Warning", msgType : "W"});
        } else {
    
          this.toastMsgService.setMsg({msg : "Failed to Update General Config",msgTitle:  "Warning", msgType : "W"});
        } 
      }
    /******* */
    getSourceConfig(){

      let uuid:any
      if(this.id){
      uuid=this.id
      }else{
        uuid="0"
      }
       this.AirConfigService
       .getSourceConfig(uuid)
       .subscribe({
         next : (res:any) => {
           if(res) {
             let data=res
             console.log(data)
            
            
              for(let j=0;j<this.sourceList.length;j++){
              for(let i=0;i<data.length;i++){
                
              const sourceItem = data.filter((sourceItem:any) => sourceItem.sourceCode === this.sourceList[j]?.code && sourceItem.supplierCode=== this.sourceList[j]?.supplierCode);
             
            
            // this.sourceList[j].sourceConfig=sourceItem
             this.sourceList[j].sourceConfig[0].sourceCode=sourceItem[0]?.sourceCode
             this.sourceList[j].sourceConfig[0].supplierCode=sourceItem[0]?.supplierCode
             this.sourceList[j].sourceConfig[0].userName=sourceItem[0]?.userName
             this.sourceList[j].sourceConfig[0].password=sourceItem[0]?.password
             this.sourceList[j].sourceConfig[0].url=sourceItem[0]?.url
             this.sourceList[j].sourceConfig[0].officeId=sourceItem[0]?.officeId
             this.sourceList[j].sourceConfig[0].clientId=sourceItem[0]?.clientId
             this.sourceList[j].sourceConfig[0].currency=sourceItem[0]?.currency
             this.sourceList[j].sourceConfig[0].profile=sourceItem[0]?.profile
             this.sourceList[j].sourceConfig[0].transactionPassword=sourceItem[0]?.transactionPassword
             this.sourceList[j].sourceConfig[0].transactionId=sourceItem[0]?.transactionId
             this.sourceList[j].sourceConfig[0].transactionProfile=sourceItem[0]?.transactionProfile
             this.sourceList[j].sourceConfig[0].farePcc=sourceItem[0]?.farePcc
             this.sourceList[j].sourceConfig[0].searchPcc=sourceItem[0]?.searchPcc
             this.sourceList[j].sourceConfig[0].b2bEnabled=sourceItem[0]?.b2bEnabled?.toString()
             this.sourceList[j].sourceConfig[0].b2eEnabled=sourceItem[0]?.b2eEnabled?.toString()

             this.sourceList[j].sourceConfig[0].b2cEnabled=sourceItem[0]?.b2cEnabled?.toString()
             this.sourceList[j].sourceConfig[0].timeBeforeSearch=sourceItem[0]?.timeBeforeSearch
             this.sourceList[j].sourceConfig[0].changeClassOption=sourceItem[0]?.changeClassOption?.toString()
             this.sourceList[j].sourceConfig[0].status=sourceItem[0]?.status
             this.sourceList[j].sourceConfig[0].state=sourceItem[0]?.state
             this.sourceList[j].sourceConfig[0].fareType=sourceItem[0]?.fareType
             this.sourceList[j].sourceConfig[0].fareBasis=sourceItem[0]?.fareBasis
             this.sourceList[j].sourceConfig[0].nonRefundableFareBasisCode=sourceItem[0]?.nonRefundableFareBasisCode
             this.sourceList[j].sourceConfig[0].productClass=sourceItem[0]?.productClass
             this.sourceList[j].sourceConfig[0].nonRefundableProductClass=sourceItem[0]?.nonRefundableProductClass



             if(sourceItem[0]?.carrierRule){

             
             this.sourceList[j].sourceConfig[0].carrierRule=this.separateValues(sourceItem[0]?.carrierRule)?.code
              console.log( this.sourceList[j].sourceConfig[0].carrierRule)
             if( this.separateValues(sourceItem[0]?.carrierRule).code==="I"){
             this.sourceList[j].sourceConfig[0].include=this.separateValues(sourceItem[0]?.carrierRule)?.value}
              if(this.separateValues(sourceItem[0]?.carrierRule).code==="X"){

             this.sourceList[j].sourceConfig[0].exclude=this.separateValues(sourceItem[0]?.carrierRule)?.value}
              }
             //this.sourceList[j].sourceConfig.changeClassOption=  this.sourceList[j].sourceConfig.changeClassOption.toString()
            // this.cdr.detectChanges(); 
             
             if(this.sourceList[j].sourceConfig[0].sourceCode===undefined){
              this.sourceList[j].showsourceSave=false

             }else{
              this.sourceList[j].showsourceSave=true

             }
              

              }
             
          }
              
          console.log(this.sourceList)
            
            
           } else {
           
           } 
         },error : (err) => {
   
         }
       }
     )
     }
    
     AddSourceConfig(code:any,supplycode:any,request:any) {
console.log(request)
if(request[0].carrierRule==="I"){
  request[0].carrierRule=request[0].carrierRule+"#"+request[0].include
        }else if(request[0].carrierRule==="X"){
          request[0].carrierRule=request[0].carrierRule+"#"+request[0].exclude
  
        }
      this.SourceRegFg=this.fb.group({
        "supplierCode": [""],
        "sourceCode": [""],
      "userName":[request[0].userName],
      "password":[request[0].password],
      "url":[request[0].url],
      "officeId":[request[0].officeId],
      "clientId":[request[0].clientId],
      "currency":[request[0].currency],
      "transactionPassword":[request[0].transactionPassword],
      "transactionId":[request[0].transactionId],
      "profile":[request[0].profile],
      "transactionProfile":[request[0].transactionProfile],
      "farePcc":[request[0].transactionProfile],
      "searchPcc":[request[0].searchPcc],
      "b2bEnabled":[request[0].b2bEnabled],
      "b2eEnabled":[request[0].b2eEnabled],

      "b2cEnabled":[request[0].b2cEnabled],
      "timeBeforeSearch":[request[0].timeBeforeSearch],
      "changeClassOption":[request[0].changeClassOption],
      "carrierRule":[request[0].carrierRule],
      "productClass":[request[0].productClass],
    "nonRefundableProductClass":[request[0].nonRefundableProductClass],
    "fareType":[request[0].fareType],
    "fareBasis":[request[0].fareBasis],
    "nonRefundableFareBasisCode":[request[0].nonRefundableFareBasisCode],
        });
      console.log(request)
      this.SourceRegFg.value.supplierCode=supplycode
      this.SourceRegFg.value.sourceCode=code
      let uuid:any
      if(this.id){
      uuid=this.id
      }else{
        uuid="0"
      }
       this.AirConfigService.saveSource(this.SourceRegFg.value,uuid)
         .subscribe({
           next : (res) => {
             if(res.status==200 || res.status==201) {
               this.toastMsgService.setMsg({msg : "Source Config Added Successfully!",msgTitle : "Success", msgType : "I"});
               this.Sourcelist()
             
   
             } else {
               const body : any = res.body;
               this.registerSourceErrorMsg(res.status,body?.result);
             } 
   
           },error : (err) => {
   
             this.registerSourceErrorMsg(err.status,err.error);
           }
         }
       )
     }
   
     registerSourceErrorMsg(status : number,msg : string) {
       if(status >=500) {
         this.toastMsgService.setMsg({msg : "Failed to save Source Config",msgTitle : "Warning", msgType : "W"});
       } else {
   
         this.toastMsgService.setMsg({msg : "Failed to save Source Config",msgTitle:  "Warning", msgType : "W"});
       } 
     }

     
     updateSourceConfig(code:any,supplycode:any,request:any) {
      console.log(request)
      if(request[0].carrierRule==="I"){
        request[0].carrierRule=request[0].carrierRule+"#"+request[0].include
              }else if(request[0].carrierRule==="X"){
                request[0].carrierRule=request[0].carrierRule+"#"+request[0].exclude
        
              }
      this.SourceRegFg=this.fb.group({
        "supplierCode": [request[0].supplierCode],
        "sourceCode": [request[0].sourceCode],
      "userName":[request[0].userName],
      "password":[request[0].password],
      "url":[request[0].url],
      "officeId":[request[0].officeId],
      "clientId":[request[0].clientId],
      "currency":[request[0].currency],
      "transactionPassword":[request[0].transactionPassword],
      "transactionId":[request[0].transactionId],
      "profile":[request[0].profile],
      "transactionProfile":[request[0].transactionProfile],
      "farePcc":[request[0].transactionProfile],
      "searchPcc":[request[0].searchPcc],
      "b2bEnabled":[request[0].b2bEnabled],
      "b2eEnabled":[request[0].b2eEnabled],

      "b2cEnabled":[request[0].b2cEnabled],
      "timeBeforeSearch":[request[0].timeBeforeSearch],
      "changeClassOption":[request[0].changeClassOption],
      "carrierRule":[request[0].carrierRule],
      "productClass":[request[0].productClass],
    "nonRefundableProductClass":[request[0].nonRefundableProductClass],
    "fareType":[request[0].fareType],
    "fareBasis":[request[0].fareBasis],
    "nonRefundableFareBasisCode":[request[0].nonRefundableFareBasisCode],
        });
     
        this.SourceRegFg.value.supplierCode=supplycode
        this.SourceRegFg.value.sourceCode=code
        let uuid:any
        if(this.id){
        uuid=this.id
        }else{
          uuid="0"
        }
      this.AirConfigService.updateSource(this.SourceRegFg.value,uuid,code,supplycode)
        .subscribe({
          next : (res) => {
            if(res.status==200 || res.status==201) {
              this.toastMsgService.setMsg({msg : "Source Config Updated Successfully!",msgTitle : "Success", msgType : "I"});
              this.Sourcelist()
            
  
            } else {
              const body : any = res.body;
              this.registerUpdateSourceErrorMsg(res.status,body?.result);
            } 
  
          },error : (err) => {
  
            this.registerUpdateSourceErrorMsg(err.status,err.error);
          }
        }
      )
    }
  
    registerUpdateSourceErrorMsg(status : number,msg : string) {
      if(status >=500) {
        this.toastMsgService.setMsg({msg : "Failed to update Source Config",msgTitle : "Warning", msgType : "W"});
      } else {
  
        this.toastMsgService.setMsg({msg : "Failed to update Source Config",msgTitle:  "Warning", msgType : "W"});
      } 
    }
    code(event:any){
      console.log(event.target)

    }
    carrierList:any=[]
    Carrierlist(){

      this.AirManagementService
      .carrierlist()
      .subscribe({
        next : (res:any) => {
          if(res) {
         let data=res
         this.carrierList=data
         

         this.getSourceConfig()
          } else {
          
          } 
        },error : (err) => {
  
        }
      }
    )
    }
   
   

    AddTourCode() {
      if(this.TourRegFg.value.expiryDate){
        const parsedDate = new Date(this.TourRegFg.value.expiryDate);
    
        // Adjust the timezone offset to convert to UTC
        const utcDate = new Date(parsedDate.getTime() - (parsedDate.getTimezoneOffset() * 60000));
    
        // Format the date as ISO 8601
        this.TourRegFg.value.expiryDate = utcDate.toISOString();
        console.log(this.TourRegFg.value.expiryDate)}
      let uuid:any
      if(this.id){
      uuid=this.id
      }else{
        uuid="0"
      }
      this.AirConfigService.saveTourCode(this.TourRegFg.value,uuid)
        .subscribe({
          next : (res) => {
            if(res.status==200 || res.status==201) {
              this.toastMsgService.setMsg({msg : "Tour Code Added Successfully!",msgTitle : "Success", msgType : "I"});
              this.tourCodeDetails()
              this.tourList()
              this.AddTourCodes=false

  
            } else {
              const body : any = res.body;
              this.registertourErrorMsg(res.status,body?.result);
            } 
  
          },error : (err) => {
  
            this.registertourErrorMsg(err.status,err.error);
          }
        }
      )
    }
  
    registertourErrorMsg(status : number,msg : string) {
      if(status >=500) {
        this.toastMsgService.setMsg({msg : "Failed to save Tour Code",msgTitle : "Warning", msgType : "W"});
      } else {
  
        this.toastMsgService.setMsg({msg : "Failed to save Tour Code",msgTitle:  "Warning", msgType : "W"});
      } 
    }


    updateTourCode() {
      
     
       
        let uuid:any
        if(this.id){
        uuid=this.id
        }else{
          uuid="0"
        }
      this.AirConfigService.updateTour(this.TourRegFg.value,uuid)
        .subscribe({
          next : (res) => {
            if(res.status==200 || res.status==201) {
              this.toastMsgService.setMsg({msg : "Tour Code Updated Successfully!",msgTitle : "Success", msgType : "I"});
              this.tourCodeDetails()
              this.tourList()
              this.AddTourCodes=false
            
  
            } else {
              const body : any = res.body;
              this.registerUpdateTourErrorMsg(res.status,body?.result);
            } 
  
          },error : (err) => {
  
            this.registerUpdateTourErrorMsg(err.status,err.error);
          }
        }
      )
    }
  
    registerUpdateTourErrorMsg(status : number,msg : string) {
      if(status >=500) {
        this.toastMsgService.setMsg({msg : "Failed to update Tour Code ",msgTitle : "Warning", msgType : "W"});
      } else {
  
        this.toastMsgService.setMsg({msg : "Failed to update Tour Code",msgTitle:  "Warning", msgType : "W"});
      } 
    }

    tourList(){
      let uuid:any
      if(this.id){
      uuid=this.id
      }else{
        uuid="0"
      }
      this.AirConfigService
      .getTourcode(uuid)
      .subscribe({
        next : (res:any) => {
          if(res) {
         let data:any=[]
         data=res
         this.tourData=data
         console.log(this.tourData)
        
         
          } else {
          
          } 
        },error : (err) => {
  
        }
      }
    )
    }

    AddPrivateFare() {
    
      let uuid:any
      if(this.id){
      uuid=this.id
      }else{
        uuid="0"
      }
      this.AirConfigService.savePrivateFare(this.fareRegFg.value,uuid)
        .subscribe({
          next : (res) => {
            if(res.status==200 || res.status==201) {
              this.toastMsgService.setMsg({msg : "Private Fare Added Successfully!",msgTitle : "Success", msgType : "I"});
             this.fareDetails()
            this.fareList()

             this.addfare=false

  
            } else {
              const body : any = res.body;
              this.registerfareErrorMsg(res.status,body?.result);
            } 
  
          },error : (err) => {
  
            this.registerfareErrorMsg(err.status,err.error);
          }
        }
      )
    }
  
    registerfareErrorMsg(status : number,msg : string) {
      if(status >=500) {
        this.toastMsgService.setMsg({msg : "Failed to save Private Fare",msgTitle : "Warning", msgType : "W"});
      } else {
  
        this.toastMsgService.setMsg({msg : "Failed to save Private Fare",msgTitle:  "Warning", msgType : "W"});
      } 
    }

    updatePrivateFare() {
      
     
       
      let uuid:any
      if(this.id){
      uuid=this.id
      }else{
        uuid="0"
      }
    this.AirConfigService.updatePrivateFare(this.fareRegFg.value,uuid)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Private Fare Updated Successfully!",msgTitle : "Success", msgType : "I"});
            this.fareDetails()
            this.fareList()
            this.addfare=false          

          } else {
            const body : any = res.body;
            this.registerUpdateFareErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {

          this.registerUpdateFareErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerUpdateFareErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to update Private Fare ",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to update Private Fare",msgTitle:  "Warning", msgType : "W"});
    } 
  }


    fareList(){
      let uuid:any
      if(this.id){
      uuid=this.id
      }else{
        uuid="0"
      }
      this.AirConfigService
      .getPrivateFare(uuid)
      .subscribe({
        next : (res:any) => {
          if(res) {
         let data:any=[]
         data=res
         this.fareData=data
         console.log(this.fareData)
        
         
          } else {
          
          } 
        },error : (err) => {
  
        }
      }
    )
    }
    onAddTour(){
      this.AddTourCodes=true
      this.action="newTour"
      this.tourCodeDetails()
  
      }
  
      onAddfare(){
        this.action="newFare"
        this.fareDetails()
       
      this.addfare=true
     
      }
      closePopup(){
        this.AddTourCodes=false
        this.tourCodeDetails()
        this.fareDetails()
        this.addfare=false
  
      }
    rowFareClick(data:any){
console.log(data)
     

       this.action="updateFare"
      this.fareRegFg=this.fb.group({
        "sourceCode": [data?.sourceCode,[Validators.required]],
        "supplierCode": [data?.supplierCode,[Validators.required]],
        "carrierCode": [data?.carrierCode,[Validators.required]],
        "priority": [data?.priority,[Validators.required]],
        "groupId": [data?.groupId],
        "domIntl":[data?.domIntl],
        "privateFareCode":[data?.privateFareCode,[Validators.required]],
        "enabled":[data?.enabled?.toString(),[Validators.required]]
      });
      this.addfare=true

    }
    rowTourClick(data:any){
console.log(data)
this.action="updateTour"

this.TourRegFg=this.fb.group({
  "sourceCode": [data?.sourceCode,[Validators.required]],
  "supplierCode": [data?.supplierCode,[Validators.required]],
  "carrierCode": [data?.carrierCode],
  "priority": [data?.priority],
  "os": [data?.os],
  "cabinClass": [data?.cabinClass],
  "viaPoint": [data?.viaPoint],
  "travelValidity": [data?.travelValidity],
  "flightRegex": [data?.flightRegex],
  "sector": [data?.sector],
  "travelBlackout": [data?.travelBlackout],
  "endorsement": [data?.endorsement],
  "classRegex": [data?.classRegex],
  "origin": [data?.origin],
  "salesValidity": [data?.salesValidity],
  "basisRegex": [data?.basisRegex],
  "destination": [data?.destination],
  "salesBlackout": [data?.salesBlackout],
  "pfTourCode": [data?.pfTourCode],
  "expiryDate": [data?.expiryDate],
  "journeyType": [data?.journeyType,],
  "netDiscount": [data?.netDiscount,],
  "domIntl": [data?.domIntl],
  "status": [data?.status.toString(),[Validators.required]],
  "state": [data?.state,],
  "code":[data?.code,[Validators.required]],
  "pfCode":[data?.pfCode],

});
this.AddTourCodes=true
    }

supplierList:any
    supplierlist(){
     
      this.AirManagementService
      .supplierlist()
      .subscribe({
        next : (res:any) => {
          if(res) {
         let data:any=[]
         data=res
         
        this.supplierList=data;
       
          } else {
          
          } 
        },error : (err) => {
  
        }
        
      }
      
    )
    }
    filterSupplierCode(item:any){
      const SUPPLIEItem = this.supplierList.filter((sourceItem:any) => sourceItem.code === item );
     // console.log(SUPPLIEItem)

      return SUPPLIEItem[0].name
    }

    separateValues(data: string): { code: string, value: string } {
      
      const parts = data.split('#');
      
      if (parts.length === 2) {
        return {
          code: parts[0].trim(),
          value: parts[1].trim()
        };
      } else {
        // Handle the case where the input string doesn't have the expected format
        // You might want to throw an error or handle it in a way that fits your application logic.
        return {
          code: '',
          value: ''
        };
      }
    }

    AddCacheConfig() {
      let uuid:any
      if(this.id){
      uuid=this.id
      }else{
        uuid="0"
      }
      this.AirConfigService.saveCache(this.CacheRegFg.value,uuid)
        .subscribe({
          next : (res) => {
            if(res.status==200 || res.status==201) {
              this.toastMsgService.setMsg({msg : "Cache Config Added Successfully!",msgTitle : "Success", msgType : "I"});
            
            this.getCache()
  
            } else {
              const body : any = res.body;
              this.registerCacheErrorMsg(res.status,body?.result);
            } 
  
          },error : (err) => {
  
            this.registerCacheErrorMsg(err.status,err.error);
          }
        }
      )
    }
  
    registerCacheErrorMsg(status : number,msg : string) {
      if(status >=500) {
        this.toastMsgService.setMsg({msg : "Failed to save Cache Config",msgTitle : "Warning", msgType : "W"});
      } else {
  
        this.toastMsgService.setMsg({msg : "Failed to save Cache Config",msgTitle:  "Warning", msgType : "W"});
      } 
    }
CacheData:any
    getCache(){
      let uuid:any
      if(this.id){
      uuid=this.id
      }else{
        uuid="0"
      }
      this.AirConfigService
      .getCache(uuid)
      .subscribe({
        next : (res:any) => {
          if(res) {
         let data:any=[]
         data=res

         if(data){
         this.showCacheUpdate=true
         this.confirmExp=true
         this.CacheExp=true
         this.searchExp=true
         this.DomCacheExp=true 
         }
        this.CacheData=data;

       this.cacheDataFields()

          } else {
          
          } 
        },error : (err) => {
  
        }
        
      }
      
    )
    }
    onAddfarRules(){
      let data:any={
        boolean:true,
        action:'newFare',
        id:''
      }
      if(this.id){
        data.id=this.id
      }else{
        data.id="0"
      }      this.DataService.deliverMsg(data)
      console.log()
    }

    sourceCodeList:any=[]
    sourceCodelist(){
    
      this.AirManagementService
      .sourceCodelist()
      .subscribe({
        next : (res:any) => {
          if(res) {
         let data=res
         this.sourceCodeList=data
         
          } else {
          
          } 
        },error : (err) => {
    
        }
      }
    )
    }
   
}